import baseUrl from '../baseUrl'
export default {
 
  getIncomeData: baseUrl + '/v1/agent/income',
  getRevenue: baseUrl + '/v1/agent/revenue-list',
  

}
